<template>
  <div class="legal-page">
    <section class="legal-hero">
      <div class="container">
        <p class="eyebrow">LEGAL</p>
        <h1>Terms and Policies</h1>
        <p class="updated">Effective Date: June 17, 2026</p>
      </div>
    </section>

    <section class="legal-content">
      <div class="container content-card">
        <article class="legal-section legal-intro">
          <p>
            <strong>Issuing Entity:</strong> GLOBAL AI LINK LIMITED, a limited
            liability company registered in Hong Kong, China, with registered
            office at RM 101A, 1/F., GENPLAS IND BUILDING, 56 HOI YUEN ROAD,
            KWUN TONG, HONG KONG (hereinafter referred to as "the Company",
            "we", "us" or "our"). These Terms of Service (hereinafter "Terms")
            constitute a legally binding agreement between us and all end users
            (hereinafter "you", "user") who access, download and use our mobile
            application published on Apple App Store, together with our official
            website
            <a
              href="https://www.globalailink.org"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.globalailink.org</a
            >. By installing and using this iOS application, you confirm that
            you have read, understood, and agreed to abide by all clauses stated
            in these Terms and Apple App Store Review Guidelines.
          </p>
        </article>

        <article class="legal-section">
          <h2>1. App Purpose &amp; Compliance Statement</h2>
          <p>
            This application is a compliant AI marketing data analysis, media
            buying and global traffic operation management tool, developed
            independently by GLOBAL AI LINK LIMITED. Founded and operated by a
            professional overseas advertising team with 5-8 years of
            cross-platform advertising operation experience, our App core
            functions cover legitimate global advertising campaign data
            statistics, AI audience behavior analysis, compliant cross-border
            media-buy data viewing, authorized multi-channel advertising asset
            management, campaign performance monitoring and third-party tracking
            system data docking services. Supported mainstream advertising
            platforms include Meta Facebook, TikTok, Taboola, Outbrain and
            MediaGo, which are all officially open for global commercial
            advertising cooperation. This App strictly complies with Apple App
            Store Review Guidelines, local internet regulations of the United
            States, European Union, Canada and other global release regions, EU
            GDPR privacy rules, CCPA California data compliance rules and Hong
            Kong cyber management policies. Our company sets up a full-time
            in-house compliance audit team, implementing double manual and AI
            content review for all advertising materials and campaign content,
            to meet Google RAF and global mainstream ad platform compliance
            standards. We will never conduct irregular search arbitrage fraud,
            unauthorized traffic hijacking, deceptive pop-up diversion, illegal
            sensitive lead collection, unregulated financial loan promotion,
            sweepstakes scam marketing, malicious competitor traffic
            interference or any behaviors violating Apple platform policies and
            global advertising laws. All built-in algorithm modules, data
            collection ports, data docking frameworks and display contents adopt
            official public iOS APIs, without invoking private system APIs,
            tampering mobile device system settings, bypassing Apple official
            audit mechanism, modifying device identification information or
            interfering with the normal operation of other third-party mobile
            applications.
          </p>
        </article>

        <article class="legal-section">
          <h2>2. User Eligibility &amp; User Obligations</h2>
          <p>
            Users must be at least 18 years old to register and use this App
            independently. Minors under 18 are prohibited from registering
            accounts, accessing advertising data and using commercial paid
            functions of this application. If you use this service on behalf of
            an enterprise organization, commercial media team or advertising
            agency, you warrant that you have complete legal business
            authorization and official operation qualification from the
            enterprise entity, and you have obtained full permission to use
            enterprise advertising assets for daily campaign management. You
            agree to use this App only for legitimate global commercial media
            buying, brand overseas marketing, compliant home service promotion,
            e-commerce drainage, formal personal loan business authorized by
            local financial institutions and standardized commercial traffic
            operation purposes. You shall not use this App to publish
            pornographic, violent, bloody, infringing, racial discriminatory,
            illegal political speech, scam, counterfeit brand and illegal
            gambling related content on any scenario. Users are strictly
            prohibited from cracking, reverse decompiling, secondary modifying,
            emulating App running environment, reselling, renting, splitting or
            sharing official App account access permission for black-industry
            trading, cross-border illegal traffic trading and unauthorized asset
            transfer. Users shall be solely legally liable and financially
            responsible for all login behaviors, campaign operations, data
            export and content release behaviors under your exclusive account.
            You shall compensate us for all platform penalty fees, account loss,
            reputation damage and economic losses caused by your violation of
            Apple platform rules, local advertising laws and these Terms of
            Service.
          </p>
        </article>

        <article class="legal-section">
          <h2>3. Account &amp; In-App Service Rules</h2>
          <p>
            Users can complete valid mobile phone or enterprise business email
            verification to register an independent exclusive App account, one
            user corresponds to one valid registered account only. We reserve
            the right to audit user account identity information, bound
            enterprise qualification and campaign business content regularly
            every month, to eliminate fake accounts, batch registered robot
            accounts and high-risk cross-region login accounts. We have the
            right to restrict function use, temporarily freeze or permanently
            terminate accounts that violate platform compliance rules, conduct
            high-risk batch operation, engage in non-compliant advertising
            promotion without prior notice. This App adopts official Apple IAP
            in-app payment system for enterprise-level data subscription,
            advanced data analysis dashboard and multi-account collaborative
            management value-added function subscription only. All in-app
            virtual membership permissions, data export quotas and collaborative
            management functions can only be used inside this App, and cannot be
            cashed out, resold, gifted, transferred or consumed across
            third-party platforms and advertising systems. We fully follow Apple
            unified refund rules, and all refund applications shall be handled
            in strict accordance with Apple Media Services terms and local
            consumer protection laws. We do not set hidden fees, mandatory
            automatic monthly/annual deduction without user explicit written
            confirmation, and all billing items, deduction cycle, service scope
            and charging standard are clearly displayed on the official payment
            confirmation page before users complete payment confirmation. Users
            can cancel automatic subscription authorization at any time via
            Apple account setting page.
          </p>
        </article>

        <article class="legal-section">
          <h2>4. Intellectual Property Rights</h2>
          <p>
            All text brand logos, visual interface designs, exclusive AI traffic
            optimization algorithm codes, backend functional frameworks,
            official website copy, enterprise brand marks and customized
            tracking tool templates inside this App belong exclusively to GLOBAL
            AI LINK LIMITED, protected by Hong Kong intellectual property law
            and global international copyright treaties. Users obtain limited
            non-exclusive personal and enterprise commercial use authorization
            only after completing official account registration and paid
            subscription activation. No individual, media team or enterprise
            institution may copy, reproduce, spread, modify, imitate,
            disassemble or commercialize our intellectual property, brand visual
            design and core algorithm technology without written official
            stamped approval issued by our Hong Kong office. All third-party
            platform trademarks, platform logos and system names involved in App
            content (including Facebook, TikTok, Taboola, Voluum, Clickflare)
            belong to their respective legal platform owners. We only quote
            these brand names for compliant business scenario description,
            official platform docking introduction and normal function
            explanation, without unauthorized trademark registration, false
            brand endorsement, brand distortion and commercial infringement
            behaviors. Users are forbidden to upload copyrighted pictures, video
            materials and copy content without authorization to our App backend
            campaign workspace.
          </p>
        </article>

        <article class="legal-section">
          <h2>5. Disclaimer &amp; Liability Limitation</h2>
          <p>
            Our App provides real-time data query, AI auxiliary campaign
            optimization, pre-landing page compliant preview and third-party
            authorized tracking system docking services based on officially
            cooperated global third-party advertising platforms. Affected by
            objective factors including regional cross-border network
            fluctuation, overseas local network policy adjustment, third-party
            advertising platform official interface iteration, Apple iOS version
            system upgrade and regional access limit adjustment, we do not
            guarantee 100% permanent uninterrupted operation, zero data delay
            and full data synchronization of all App functions. We shall not be
            liable for indirect business profit loss, expected revenue loss and
            partner cooperation loss caused by objective uncontrollable service
            suspension and data delay. We adopt industry-standard end-to-end
            data encryption, account login IP verification, device binding
            protection and backend access permission classification measures to
            protect user account information, enterprise advertising asset data
            and business privacy data. But we cannot absolutely avoid network
            security risks, account theft risks and data leakage risks caused by
            user's improper password preservation, multi-device disorder login,
            active account information disclosure and clicking unknown external
            links. We will never develop hidden bypass functions, never assist
            users to bypass regional platform access restrictions, evade
            advertising material review, violate local financial advertising
            laws and conduct non-compliant cross-border paid promotion business.
            We will actively report abnormal high-risk user behaviors to Apple
            official audit team when necessary.
          </p>
        </article>

        <article class="legal-section">
          <h2>6. Term Amendment &amp; Jurisdiction</h2>
          <p>
            We have the right to update these Terms irregularly to adapt to
            updated Apple App Store audit rules, global cross-border advertising
            regulatory requirements, EU data protection clauses and Hong Kong
            enterprise service management regulations. Updated revised clauses
            will be officially published on our official website
            <a
              href="https://www.globalailink.org"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.globalailink.org</a
            >
            homepage and App system setting terms page, with updated effective
            date marked clearly. Users' continued login, account use and
            campaign operation after terms update represent automatic acceptance
            of the latest revised Terms. This legal service agreement is
            governed by the laws of Hong Kong, China. Any civil dispute,
            business cooperation dispute and account right dispute arising from
            App use shall be settled through friendly equal negotiation between
            both parties first; if negotiation cannot reach an agreement, all
            disputes shall be submitted to the competent people's court in Kwun
            Tong, Hong Kong for final judgment and settlement. Our company
            maintains long-term positive communication and full cooperation with
            Apple official review team. Once our App functions, business
            description and service clauses are confirmed to violate Apple
            platform rules, we will revise relevant content, adjust business
            display and optimize compliance clauses immediately within 3 working
            days to meet official audit standards. We reserve the right to
            adjust partial App functions for platform compliance iteration
            without affecting core user business use.
          </p>
        </article>

        <article class="legal-section">
          <h2>7. Contact Us</h2>
          <p>
            If you have any questions or want to learn more about the Services,
            please contact us at
            <a href="mailto:support@globalailink.org"
              >support@globalailink.org</a
            >.
          </p>
        </article>

        <article class="legal-section">
          <h2>8. Apple App Store Exclusive Terms</h2>
          <p>
            Your access and utilization of all functional services provided by
            our native iOS mobile application distributed on the official Apple
            App Store platform (hereinafter referred to as "iOS Application")
            shall be governed and restricted by all valid rules, usage policies,
            regulatory specifications and service agreements issued by Apple
            Inc., together with its global affiliated companies, subsidiary
            institutions and authorized operating entities (collectively
            referred to as "Apple Group"). Users shall fully comply with the
            latest version of Apple Media Services Terms and Conditions
            published and updated on Apple's official legal webpage:
            <a
              href="https://www.apple.com/legal/internet-services/itunes/"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.apple.com/legal/internet-services/itunes/</a
            >. In the event of clause conflict, rule inconsistency, right
            obligation divergence between the content stipulated in this Article
            25 and any other clauses recorded in the whole Terms of Service, all
            rules and provisions under this independent Article 25 shall prevail
            and be implemented preferentially for all iOS App users. You hereby
            voluntarily confirm, recognize and agree to the following binding
            statements without reservation. First, if any third-party
            advertising data, public platform content, cooperative brand
            information and external business materials are displayed, linked or
            browsed through our iOS Application, the original third-party
            content provider shall bear full legal liability, content compliance
            liability and information security liability for all released
            third-party content. Our company will not assume joint liability for
            unauthorized risk, content violation, copyright infringement and
            illegal information involved in external third-party content.
            Second, we reserve independent operational management right over
            in-platform user display weight, account identity status, business
            data ranking and homepage exposure weight inside our iOS App. We may
            adjust the above user-related display indicators reasonably at any
            time based on account compliance assessment, daily operation
            maintenance, platform risk control and Apple official review
            requirements, without prior individual notification to users. Third,
            users explicitly acknowledge that Apple Group does not provide
            licensing, operation, after-sales and technical support services for
            our application. Our company GLOBAL AI LINK LIMITED is the sole
            legal party that grants end users limited use license, releases iOS
            application services, undertakes business after-sales and assumes
            service liability. This complete Terms of Service establishes a
            legal contractual relationship solely between our company and end
            users, and Apple is not a contracting party, liability-bearing party
            or service guarantee party of this agreement. Apple only acts as an
            independent neutral distribution platform to provide application
            download channel and platform audit services. Meanwhile, users agree
            that Apple has no obligation to participate in account dispute
            mediation, service refund negotiation, business consulting response
            and user right protection matters arising from the use of our iOS
            App. All user complaints, service disputes, account appeal
            applications and liability claims shall be negotiated and settled
            directly with our Hong Kong registered company, instead of claiming
            relevant rights against Apple. We abide by all App Store
            distribution rules, and will revise App operation behaviors
            immediately once violating Apple platform distribution policies.
          </p>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "TermsAndPoliciesPage",
};
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background-image: url("../../../static/images/publisher/hero-bg.jpg");
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-color: #f0f7ff;
  color: #1c2b4e;
}

.container {
  max-width: 960px;
  margin: 0 auto;
  padding: 0 20px;
}

.legal-hero {
  padding: 140px 0 32px;
  text-align: center;
}

.eyebrow {
  margin: 0 0 10px;
  font-size: 13px;
  letter-spacing: 1.6px;
  color: #4b89ff;
  font-weight: 700;
}

.legal-hero h1 {
  margin: 0 0 10px;
  font-size: 44px;
  line-height: 1.2;
}

.updated {
  margin: 0;
  font-size: 14px;
  color: #64748b;
}

.legal-content {
  padding: 0 0 90px;
}

.content-card {
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(75, 137, 255, 0.12);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(28, 43, 78, 0.08);
  padding: 36px 40px;
}

.legal-section {
  margin-bottom: 28px;
}

.legal-intro {
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(75, 137, 255, 0.12);
}

.legal-section p + p {
  margin-top: 12px;
}

.legal-section:last-child {
  margin-bottom: 0;
}

.legal-section h2 {
  margin: 0 0 12px;
  font-size: 22px;
  line-height: 1.35;
}

.legal-section p {
  margin: 0;
  font-size: 16px;
  line-height: 1.8;
  color: #475569;
}

.legal-section a {
  color: #296dff;
  text-decoration: none;
}

.legal-section a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .legal-hero {
    padding-top: 116px;
  }

  .legal-hero h1 {
    font-size: 32px;
  }

  .content-card {
    padding: 24px 20px;
  }

  .legal-section h2 {
    font-size: 20px;
  }
}
</style>
